
import {popAlert,ModalStyles} from '../../lib/Notification'; 
import {getJson,postObjectWithApiError,IResultAndError} from '../../lib/ChoiceApi';  
import {IExportDataRequestData,IExportDataResponse,IExportDataInput,IDownLoadInput,ITableSearchResponse} from '../../lib/Models/ExportDataRequestModel';
import { assertInternally } from '../Environment';
 
export enum ErrorReturnMessage {
    delete = "Unable to remove export request.",
    export = "Unable to download export request."
};
export async function deleteExportRequest(export_data_request_id: IExportDataInput): Promise<IResultAndError<IExportDataResponse>>{
    return postObjectWithApiError("api/ExportDataRequests/DeleteUserExportRequest", export_data_request_id);
};

export const getExportRecords = async (): Promise<IExportDataRequestData[]> => {
    const result = await getJson(`api/ExportDataRequests/GetUserExportRequests`);
    if (!result) {
        throw new Error("Failed to retrieve export records.");
    }
    return result as IExportDataRequestData[];
}
export const userDownLoad = async (payload :IDownLoadInput): Promise<ITableSearchResponse> => {
    const excel_data_src = `api/Export/TableSearch/${payload.ExportDataRequestID}/${payload.SheetName}`;
    const result = await getJson(excel_data_src);
    if (!result) {
        await popAlert(ErrorReturnMessage.export,"Download Export Data Request",ModalStyles.danger);
    }
    return result as ITableSearchResponse;
} 

export function downloadExportRequestURL(requestID?: number, fileName?: string): string
{
  if (!requestID || !fileName) {
    assertInternally("downloadExportRequestURL: requestID and fileName are required.");
  }

  return `api/Export/TableSearchDownLoad/${requestID}/${fileName}`;
}